import _ from 'lodash';
import qs from 'qs';
import queryStringOption from './queryStringOption';

const isEmptyValue = (value) => value === undefined || value === null || value === '' || ((Array.isArray(value) || _.isObject(value)) && _.isEmpty(value));

const replaceSearchedKeys = (params, values) => {
  const searchedKeys = Object.keys(values);
  const updatedParams = new URLSearchParams(params);
  // Remove nested keys too (e.g. `identifiers[0].label` for `identifiers`), so stale array entries don't survive.
  Array.from(updatedParams.keys())
    .filter((key) => searchedKeys.includes(key.split(/[.[]/)[0]))
    .forEach((key) => updatedParams.delete(key));

  new URLSearchParams(qs.stringify(_.omitBy(values, isEmptyValue), queryStringOption)).forEach((value, key) => updatedParams.append(key, value));

  return updatedParams;
};

export default replaceSearchedKeys;
